import { render, staticRenderFns } from "./ChatConversation.vue?vue&type=template&id=fc2dd564&"
import script from "./ChatConversation.vue?vue&type=script&lang=ts&"
export * from "./ChatConversation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports